// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".fusion{background:red;padding:10px;border:1px solid #000}", ""]);
// Exports
module.exports = exports;
